<script setup lang="ts">
import { ref } from 'vue';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import HoeppnerButton from './HoeppnerButton.vue'

import HoeppnerLogo from '@/components/images/hoeppner.svg'

import RKLogo from '@/components/images/rk.svg'
import IRKLogo from '@/components/images/irk.svg'
import DangeroursMaterialsLogo from '@/components/images/biohazard_new.svg'
import ProcessLogo from '@/components/images/processmanagement.svg'

import { useViewStore } from '@/stores/viewStore'

const viewStore = useViewStore();

const props = defineProps({
  userInfo: { type: Object },
  customerInfo: { type: Object },
  specsInfo: { type: Object },
});

//const is_rg = computed(() => props.customerInfo.value !== null && (props.customerInfo.value.is_hoeppner || props.customerInfo.value.is_registry));
const show_hoeppner_logo = props.userInfo == null || props.customerInfo.is_hoeppner
const test_registry = (registry) => props.userInfo != null && props.customerInfo[registry]
const is_registry = test_registry("is_registry")
const is_int_registry = test_registry("is_int_registry")
const is_dangergoods_registry = test_registry("is_dangergoods_registry")
const is_processmanager = test_registry("is_processmanager")

function handleGefahrstoffeClick() {
  viewStore.setActionView('registry.gefahrstoffe')
}

const QWIKI_URL = 'https://www.modell-aachen.de/en/qwiki'
function handleProzessmanagementClick() {
  window.open(QWIKI_URL, '_blank', 'noopener,noreferrer')
}

</script>

<template>
  <div class="min-h-screen flex items-center justify-center bg-white">
    <!-- Main Container C -->
    <div class="w-4/5 flex flex-col bg-white shadow-2xl overflow-hidden">
      <!-- Banner -->
      <div class="flex justify-between items-center px-16 bg-white">
        <HoeppnerLogo v-if="show_hoeppner_logo" />
        <img v-if="!show_hoeppner_logo" :src="`/logo/${customerInfo.id}`" alt="hoeppner Logo"
          class="h-48 w-48 object-contain" />

        <button class="bg-black text-white px-4 py-2">Jetzt Kontakt aufnehmen</button>
      </div>

      <!-- Main Content -->
      <div class="flex flex-1 px-16" style="paddingBottom: 40px">
        <slot />

        <!-- Promotional Content P -->
        <div class="w-1/2 flex flex-col justify-center">
          <div class="flex items-start space-x-4">
            <div class="h-24 w-24 flex items-center justify-center rounded-lg">
              <RKLogo />
            </div>
            <div>
              <h3 class="font-semibold">Rechtskataster</h3>
              <p class="text-sm text-gray-600" style="marginBottom: 10px">Ihr digitales System zur Erfassung, Bewertung
                und Nachverfolgung rechtlicher Verpflichtungen.</p>
              <HoeppnerButton @click="viewStore.setViewRegistry()" :disabled="!is_registry" text="Zum Rechtskataster"
                width="300px" marginTop="20px" bgClass="greenbutton" />
            </div>
          </div>
          <div class="flex items-start space-x-4" style="marginTop: 20px">
            <div class="h-24 w-24 flex items-center justify-center rounded-lg">
              <IRKLogo />
            </div>
            <div>
              <h3 class="font-semibold">Internationales Rechtskataster</h3>
              <p class="text-sm text-gray-600" style="marginBottom: 10px">Erfüllen Sie internationale
                Compliance-Anforderungen mit einem zentralen Überblick über alle Standorte.</p>
              <HoeppnerButton :disabled="!is_int_registry" text="Zum Internationalen Rechtskataster" width="300px"
                marginTop="20px" bgClass="greenbutton" />
            </div>
          </div>
          <div class="flex items-start space-x-4" style="marginTop: 20px">
            <div class="h-24 w-24 flex items-center justify-center rounded-lg">
              <DangeroursMaterialsLogo class="w-24 h-24" />
            </div>
            <div>
              <h3 class="font-semibold">Gefahrstoffmanagement</h3>
              <p class="text-sm text-gray-600" style="marginBottom: 10px">Digitales Gefahrstoffmanagement für maximale
                Transparenz und einfache Nachverfolgung.</p>
              <HoeppnerButton @click="handleGefahrstoffeClick" :disabled="!is_dangergoods_registry"
                text="Zum Gefahrstoffmanagement" width="300px" bgClass="greenbutton" />
            </div>
          </div>
          <div class="flex items-start space-x-4" style="marginTop: 20px">
            <div class="h-24 w-24 flex items-center justify-center rounded-lg">
              <ProcessLogo class="w-24 h-24" />
            </div>
            <div>
              <h3 class="font-semibold">Prozessmanagement</h3>
              <p class="text-sm text-gray-600" style="marginBottom: 10px">Interaktive QM-Software für Prozessdokumentation,
                Wissensmanagement und zentrale Nachverfolgung.</p>
              <HoeppnerButton @click="handleProzessmanagementClick" :disabled="!is_processmanager"
                text="Zum Prozessmanagement" width="300px" bgClass="greenbutton" />
            </div>
          </div>
        </div>
      </div>

      <!-- Footer Image -->
      <div>
        <img src="@/components/images/footer.png" alt="Footer" class="w-full h-420 object-cover" />
      </div>
    </div>
  </div>
</template>

<style>

.w-button {
    width: 300px !important;	
}

.hoeppner-bg {
	background-color: #F4F3F3 !important;
	border-radius: 0 !important;
}

.greenbutton {
	background-color: #80BA27 !important;
}
</style>